/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.app.list.desc':
    '管理员可以在当前页面管理已经添加的所有应用，应用可以实现单点登录和数据同步能力。',
  'pages.app.list.title': '应用列表',
  'pages.app.list.tool_bar_render.add_app': '添加应用',
  'pages.app.list.tool_bar_render.app_group': '分组管理',
  'pages.app.list.metas.title': '应用名称',
  'pages.app.list.metas.protocol': '协议类型',
  'pages.app.list.metas.protocol.oidc': 'OIDC',
  'pages.app.list.metas.protocol.jwt': 'JWT',
  'pages.app.list.metas.protocol.form': '表单代填',
  'pages.app.list.actions.disable_app': '确定要禁用该应用吗？',
  'pages.app.list.actions.disable_app.confirm_content': '禁用后应用将无法正常使用。',
  'pages.app.list.actions.enable_app': '确定要启用该应用吗？',
  'pages.app.list.actions.enable_app.confirm_content': '启用后应用将恢复到正常使用。',
  'pages.app.list.actions.delete.confirm_title': '确定要删除此应用？',
  'pages.app.list.actions.delete.confirm_content': '删除操作无法恢复，请谨慎操作！',
};
